import { Button, Col, If, Modal, Notification, Row, Text } from '@app/components'
import { db, metaMask } from '@app/services'
import { Progress, Steps } from 'antd'
import { doc, onSnapshot } from 'firebase/firestore'
import React, { useEffect } from 'react'

import { CoastIcon } from '~public'

const addToken = () => {
  if (window.ethereum) {
    try {
      metaMask
        .watchAsset({
          address: process.env.NEXT_PUBLIC_COAST_ADDRESS,
          symbol: 'CST',
          decimals: 6,
          image: 'coast.png',
        })
        .then(() => {
          Notification({ message: 'Coast added successfully to Metamask', type: 'success' })
        })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error adding toekn to users wallet', error)
    }
  }
}

export const BuyPendingModal: React.FC<any> = ({ pending, setPending, percent, setPercent, transactionId }) => {
  const step = Math.floor(percent / 33)

  useEffect(() => {
    if (transactionId !== undefined && transactionId !== '') {
      const unsub = onSnapshot(doc(db, 'Transactions', transactionId), (doc) => {
        if (doc.exists) {
          const mintStep = doc.data().mintStep
          switch (mintStep) {
            case 0:
              if (doc.data().status == 'Failed') {
                setPercent(0)
                setPending(0)
                Notification({ message: 'Transaction failed to process', type: 'error' })
              }
            case 1:
              setPercent(33)
              break
            case 2:
              setPercent(66)
              break
            case 3:
              setPercent(100)
              setPending(0)
              Notification({ message: 'Transaction completed successfully', type: 'success' })

              break
          }
        }
      })

      return () => unsub()
    }
  }, [transactionId])

  return (
    <Modal
      title={pending == 1 ? 'Waiting for Mint' : pending == 3 ? 'Waiting for Burn' : 'Waiting for funds to transfer'}
      open={pending > 0}
      centered
      footer={false}
      width={1000}
    >
      <Row>
        <Col span={24}>
          <If condition={pending == 1 || pending == 3}>
            <Text> Please confirm transaction in Wallet</Text>
          </If>
          <If condition={pending == 2}>
            <Row>
              <Col span={24}>
                <Steps current={step} size="small">
                  <Steps.Step
                    description={
                      <div style={{ paddingTop: '30px', marginLeft: '40px', textAlign: 'center' }}>
                        Transferring Funds
                      </div>
                    }
                  />
                  <Steps.Step
                    description={
                      <div style={{ paddingTop: '30px', marginLeft: '40px', textAlign: 'center' }}>
                        Confirming Transaction
                      </div>
                    }
                  />
                  <Steps.Step
                    description={
                      <div style={{ paddingTop: '30px', marginLeft: '40px', textAlign: 'center' }}>Approving CST</div>
                    }
                  />
                  <Steps.Step />
                </Steps>

                <Progress type={'line'} percent={percent} />
              </Col>
              <Col span={24}>
                <Button onClick={() => addToken()}>
                  Add to Wallet <CoastIcon style={{ width: 25, marginLeft: 8 }} />
                </Button>
              </Col>
            </Row>
          </If>
        </Col>
      </Row>
    </Modal>
  )
}
